export const HEALTHCHECK_BOARDING_ACTION = 'healthcheckBoardingAction';

export const GOTO_STEP_ON_BOARDING_ACTION = 'goToStepOnBoardingAction';

export const ADD_ON_BOARDING_ACTION = 'addOnBoardingAction';
export const GET_ON_BOARDING_ACTION = 'getOnBoardingAction';
export const RESET_ON_BOARDING_ACTION = 'resetOnBoardingAction';
